export default "__VITE_ASSET__DV7T_Iw1__"